import { render, staticRenderFns } from "./registration_email.vue?vue&type=template&id=07493c03&"
import script from "./registration_email.vue?vue&type=script&lang=js&"
export * from "./registration_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports